import { getMessages } from './getMessages';
import { TThunkAction } from '../../types/redux/thunk';
import { ERequestSource } from '../../utils/logging/publicApiDiagnostics';
import { updateChatImages } from '../chatImages';

/**
 * Пагинация сообщений текущего чата
 */
export const getNextMessages = (): TThunkAction<Promise<void>> => async (dispatch, getState) => {
  const { chatWindow, chatList, openedChats } = getState();

  const currentOpenedChatId =
    chatWindow.currentOpenedChatId || chatList.removedFromSpamChatId || chatList.removedFromArchiveChatId;

  const currentChat = currentOpenedChatId !== undefined && openedChats[currentOpenedChatId];
  const images = currentChat && currentChat.images;

  if (images && images.files && images.page.canLoadMore) {
    dispatch(updateChatImages({ chatId: currentOpenedChatId, offset: images.files.length }));
  }

  await dispatch(getMessages(currentOpenedChatId as string, ERequestSource.MessagesNextPage));
};
